import {useLocalStorage} from '@aboutyou/storage';
import {useMemo} from 'react';
import {DevicePushState} from './enums/DevicePushState';
import {getDefaultState} from './utils/getDeviceDefaultPushState';

export const DEVICE_PUSH_STATE_LOCAL_STORAGE_KEY = 'ay_device_push_state';

export const useDevicePushState = () => {
  const defaultState = useMemo(() => getDefaultState(), []);
  const [devicePushState, setDevicePushState] =
    // eslint-disable-next-line no-restricted-syntax
    useLocalStorage<DevicePushState>({
      key: DEVICE_PUSH_STATE_LOCAL_STORAGE_KEY,
      defaultValue: defaultState,
    });

  const updateDevicePushState = (
    newValue?: DevicePushState,
  ): DevicePushState => {
    if (!('Notification' in window)) {
      setDevicePushState(DevicePushState.BLOCKED);
      return DevicePushState.BLOCKED;
    }

    if (newValue) {
      setDevicePushState(newValue);
      return newValue;
    }

    if (!devicePushState) {
      return DevicePushState.NOT_SENT;
    }

    let returnValue: DevicePushState = devicePushState;
    switch (Notification.permission) {
      case 'granted':
        switch (devicePushState) {
          case DevicePushState.SENT:
          case DevicePushState.DISABLED:
            setDevicePushState(devicePushState);
            break;
          case DevicePushState.NOT_SENT:
          case DevicePushState.BLOCKED:
            setDevicePushState(DevicePushState.SENT);
            returnValue = DevicePushState.SENT;
            break;
        }
        break;
      case 'denied':
        switch (devicePushState) {
          case DevicePushState.SENT:
          case DevicePushState.NOT_SENT:
          case DevicePushState.BLOCKED:
          case DevicePushState.DISABLED:
            setDevicePushState(DevicePushState.BLOCKED);
            returnValue = DevicePushState.BLOCKED;
            break;
        }
        break;
      case 'default':
        switch (devicePushState) {
          case DevicePushState.SENT:
          case DevicePushState.NOT_SENT:
          case DevicePushState.BLOCKED:
            setDevicePushState(DevicePushState.NOT_SENT);
            returnValue = DevicePushState.NOT_SENT;
            break;
          case DevicePushState.DISABLED:
            break;
        }
        break;
    }
    return returnValue;
  };

  return {devicePushState, updateDevicePushState};
};
